module.exports = __webpack_public_path__ + "static/env/$env.bin.js";


//////////////////
// WEBPACK FOOTER
// ./src/config/$env
// module id = 1555
// module chunks = 0